import { PropsWithChildren, ReactElement } from 'react';
import { noop } from 'lodash';

import { IonReorderGroup, ItemReorderCustomEvent } from '@ionic/react';

import { ReorderHandler } from './ReorderHandler/ReorderHandler';
import { OnCompleteParams } from './Reorder.types';

export type ReorderProps<T extends object> = PropsWithChildren<{
  items?: T[];
  disabled?: boolean;
  onComplete?: (params: OnCompleteParams<T>) => void;
}>;

export interface ReorderComponent {
  <T extends object = {}>(props: ReorderProps<T>): ReactElement;
  Handler: typeof ReorderHandler;
}

export const Reorder: ReorderComponent = ({
  children,
  disabled = false,
  onComplete = noop,
  items: initialItems = [],
}) => {
  const handleOnItemReorder = ({
    detail: { from, to, complete },
  }: ItemReorderCustomEvent) => {
    const items = complete(initialItems);
    onComplete({ from, to, items });
  };

  return (
    <IonReorderGroup disabled={disabled} onIonItemReorder={handleOnItemReorder}>
      {children}
    </IonReorderGroup>
  );
};

Reorder.Handler = ReorderHandler;
